import React, { useEffect, useState, useContext } from "react";

import "./App.scss";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Main from "./components/Screens/Main/Main";
import authService from "./services/AuthService";
import SplashScreen from "./components/SplashScreen/SplashScreen";
import "ol/ol.css";
import "react-toastify/dist/ReactToastify.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { createTheme, MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
// import i18n from "./utils/i18n";
import { useTranslation } from "react-i18next";
import "dayjs/locale/es";

import en from "./utils/i18n/en";
import es from "./utils/i18n/es";
import pt from "./utils/i18n/pt";
import i18next from "i18next";
import Notiflix from "notiflix";

Notiflix.Loading.init({
  svgColor: "#0000FF", // Cambia el color del spinner a rojo
});

i18next.addResourceBundle("en", "main", en);
i18next.addResourceBundle("es", "main", es);
i18next.addResourceBundle("pt", "main", pt);

const theme = createTheme({
  /** Put your mantine theme override here */
});

function App() {
  const { i18n } = useTranslation();

  return (
    <div className="App">
      <MantineProvider theme={theme}>
        <DatesProvider settings={{ locale: i18n.language }}>
          <BrowserRouter>
            <Routes>
              <Route path="/token/:token/redirect" element={<TokenHandler />} />
              <Route path="/main" element={<PrivateRoute component={Main} />} />
              <Route
                path="*"
                element={
                  <ExternalRedirect
                    to={process.env.REACT_APP_FALLBACK_NO_PROJECT_URL}
                  />
                }
              />
            </Routes>
          </BrowserRouter>
        </DatesProvider>
      </MantineProvider>
    </div>
  );
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  // console.log("PrivateRoute");
  useEffect(() => {
    const tokenExists = authService.getToken() !== null;

    if (!tokenExists) {
      const currentUrl = encodeURIComponent(window.location.href);
      const redirectUrl = `${process.env.REACT_APP_FALLBACK_NO_PROJECT_URL}/redirect?url=${currentUrl}`;
      // console.log("redirectUrl", redirectUrl);

      // window.location.href = redirectUrl;
    }
  }, []);

  return <Component {...rest} />;
};

const ExternalRedirect = ({ to }) => {
  // console.log("ExternalRedirect");
  useEffect(() => {
    window.location.href = to; // Redirige a la web externa
  }, []);

  return null; // No renderiza nada
};

const TokenHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("url");
  const { token } = useParams(); // Captura el 'token' de la ruta
  // console.log("TokenHandler token", token);
  // console.log("TokenHandler redirect", redirect);

  useEffect(() => {
    authService.saveToken(token);
    navigate(redirect);
  }, []);

  return;
  // return <SplashScreen />;
};

export default App;
